import { IScriptTableBehavior } from "./IScriptTableBehavior";

export interface IScriptTableBehaviorSpecifiable {
  scriptTableBehavior: IScriptTableBehavior;
}

export function instanceOfIScriptTableBehaviorSpecifiable(instance: any): instance is IScriptTableBehaviorSpecifiable {
  return instance
    && (instance.scriptTableBehavior !== undefined);
}
